import { SequenceMenu } from '@sequencehq/core-components'
import { useDownloadInvoicePdf } from 'modules/Invoices/hooks/useDownloadInvoicePdf'
import { usePermissions } from 'lib/rbac'
import { Dashboardv99990101Api } from '@sequencehq/api/dashboard/v99990101'

export const DownloadInvoice = (props: {
  invoiceId: string
  invoiceNumber: string | undefined
  invoiceStatus: Dashboardv99990101Api.Invoices.InvoiceStatus
}) => {
  const { downloadPdf } = useDownloadInvoicePdf()
  const { can } = usePermissions()

  if (!can('org.invoice:read')) {
    return null
  }

  return (
    <SequenceMenu.Item
      data-testid="invoices.downloadInvoice.menuItem"
      uuid="download-invoice"
      label="Download invoice as PDF"
      onClick={() => {
        downloadPdf({
          invoiceId: props.invoiceId,
          invoiceNumber: props.invoiceNumber,
          invoiceStatus: props.invoiceStatus
        })
      }}
    />
  )
}
